// @flow
import * as React from "react";
import { connect } from "react-redux";
import { Grid, Header } from "semantic-ui-react";
import { formValues, Field, type FormProps } from "redux-form";

import { postCodeValidator, locationIdValidator } from "../../misc/validators";
import { fetchLocations, resetLocations } from "../../../../../redux/actions/locations";
import { isPresent as isRequired } from "../../../../../Commons/Utilities/validators";
import GridRowReusable from "../../../../ShortOfferForm/components/SubComponents/GridRowReusable";
import PostalCodeInput from "../../../../../Commons/Components/redux-form-components/Location/PostalCodeInput";
import LocationSelect from "../../../../../Commons/Components/redux-form-components/Location/LocationSelect";

import "./PostCodeAndSelectable.scss";

type Props = {
  ...FormProps,
  required: boolean,
  resetLocations: Function,
  resetSection: Function,
  t: typeof TFunction,
  fetchLocations: Function,
  categorySlug: ?string,
  name: ?string,
  error?: ?string,
  value?: ?string,
  isLoading?: ?boolean,
  profile: boolean, // if set to false, the fields will stack. If true, they will be next to each other,
  textAlign: string,
  launchEvent?: boolean,
  unfolding?: boolean,
  postalCode?: string,
  postalcode?: string,
  forceMobile?: boolean,
  compact?: boolean,
  tags?: Object,
};

class PostCodeAndSelectable extends React.PureComponent<Props> {
  static defaultProps = {
    categorySlug: "electricity", //TODO this is not the slug, it is the... type?
    profile: true,
  };

  PostalcodeField = () => {
    const {
      t,
      required,
      categorySlug,
      launchEvent,
      profile,
      resetLocations,
      change,
      resetSection,
      fetchLocations,
      forceMobile,
      tags,
    } = this.props;
    return (
      <Field
        name={"postalcode"}
        placeholder={t("formFieldDescriptors.postalcode.placeholder")}
        validate={required ? [postCodeValidator, isRequired] : postCodeValidator}
        categorySlug={categorySlug}
        launchEvent={launchEvent}
        component={PostalCodeInput}
        profile={profile}
        resetLocations={resetLocations}
        change={change}
        resetSection={resetSection}
        fetchLocations={fetchLocations}
        forceMobile={forceMobile}
        style={!forceMobile && { marginBottom: "1rem" }}
        compact={forceMobile}
        tags={tags}
      />
    );
  };

  LocationField = ({ showHint }: { showHint?: boolean }) => {
    const { launchEvent, required, t, change, categorySlug, postalCode, postalcode, forceMobile } = this.props;
    return (
      <Field
        name={"locationId"}
        validate={required ? [locationIdValidator, isRequired] : locationIdValidator}
        t={t}
        change={change}
        component={LocationSelect}
        launchEvent={launchEvent}
        showHint={showHint}
        categorySlug={categorySlug}
        postalCode={postalCode || postalcode}
        style={!forceMobile && { marginBottom: "1rem" }}
        forceMobile={forceMobile}
      />
    );
  };

  render() {
    const { t, profile, textAlign, unfolding, forceMobile, compact } = this.props;
    const { LocationField, PostalcodeField } = this;

    if (profile) {
      return (
        <Grid.Row>
          <Grid.Column width={4}>
            <Header as={"h4"}>{t("formFieldDescriptors.postalcode.description")}</Header>
          </Grid.Column>
          <Grid.Column width={12}>
            <Grid columns={2} stackable>
              <Grid.Column>
                <PostalcodeField />
              </Grid.Column>
              <Grid.Column>
                <LocationField />
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      );
    } else {
      return (
        <>
          <GridRowReusable
            unfolding={unfolding}
            unfoldingPrimary
            headerString={t("formFieldDescriptors.postalcode.description")}
            textAlign={textAlign}
            forceMobile={forceMobile}
            leftCompact={compact}
          >
            <PostalcodeField />
          </GridRowReusable>
          <GridRowReusable
            unfolding={unfolding}
            headerString={t("formFieldDescriptors.location.description")}
            textAlign={textAlign}
            forceMobile={forceMobile}
            leftCompact={compact}
          >
            <LocationField showHint />
          </GridRowReusable>
        </>
      );
    }
  }
}

const mapDispatchToProps = { fetchLocations, resetLocations };

const mapStatetoProps = ({ user: { user }, locations: { isFetching } }) => {
  return user !== null
    ? {
        isLoading: isFetching,
      }
    : {
        isLoading: null,
      };
};

export default connect(mapStatetoProps, mapDispatchToProps)(formValues("postalcode")(PostCodeAndSelectable));
